export class AlertModel {

  constructor(public className: string, public multiLine: boolean, public title: string, public message: string) {
  }
}
